(function() {
  vtex.define('shipping/script/setup/extensions',['shipping/script/module/alphanumponc'], function(alphanumponc) {
    var Extensions;
    return Extensions = (function() {
      function Extensions() {}

      window.ParsleyConfig = $.extend(true, {}, window.ParsleyConfig || {}, {
        validationThreshold: 1,
        animate: false
      });

      window.ParsleyValidator.addValidator('alphanumponc', alphanumponc, 32);

      /*
        Capitalize
        Usage:
        {value|capitalize}
      */


      dust.filters.capitalize = function(text) {
        return _.capitalizeSentence(text);
      };

      /*
        Slugify
        Usage:
        {myReference|slugify}
      */


      dust.filters.slugify = function(value) {
        var plain, regex, specialChars;
        if (value == null) {
          return value;
        }
        specialChars = "ąàáäâãåæćęèéëêìíïîłńòóöôõøśùúüûñçżź ";
        plain = "aaaaaaaaceeeeeiiiilnoooooosuuuunczz-";
        regex = new RegExp('[' + specialChars + ']', 'g');
        value += "";
        return value.replace(regex, function(char) {
          return plain.charAt(specialChars.indexOf(char));
        }).toLowerCase();
      };

      return Extensions;

    })();
  });

}).call(this);

